import { createContext } from '@/utils/createContext';
import React from 'react';

import { IQuestionState } from '../../types';

function useQuestionState(props: IQuestionState) {
  const question = React.useRef(props).current;

  const [activePanes, setActivePanes] = React.useState<string[]>([]);

  const togglePane = React.useCallback((pane: string) => {
    setActivePanes((old) => {
      if (old.includes(pane)) {
        return old.filter((p) => p !== pane);
      }
      return [...old, pane];
    });
  }, []);

  return {
    question,
    activePanes,
    togglePane,
  };
}

export type QuestionItemContextValue = ReturnType<typeof useQuestionState>;

const [QuestionItemContext, useQuestionItem] = createContext<
  QuestionItemContextValue
>();

export const QuestionItemProvider: React.FC<{ question: IQuestionState }> = ({
  children,
  question,
}) => {
  return (
    <QuestionItemContext value={useQuestionState(question)}>
      {children}
    </QuestionItemContext>
  );
};

export { useQuestionItem };
